module.exports = "images/password-meter.png";